import React, { useState, useEffect } from 'react';
import { SessionActivity } from "./interface";

interface DateFilterProps {
  interactions: SessionActivity[];
  setDateFilter: (dateFilter: { start: Date; end: Date }) => void;
}

export const filterDataForWeek = (data: SessionActivity[], startDate: Date, endDate: Date): SessionActivity[] => {
  const start = startDate.getTime();
  const end = endDate.getTime();

  return data.filter(item => {
    const itemDate = new Date(item.sessionStartTime).getTime();
    return itemDate >= start && itemDate <= end;
  });
};

export const DateFilter: React.FC<DateFilterProps> = ({ interactions, setDateFilter }) => {
  const [selectedWeek, setSelectedWeek] = useState<{ start: Date; end: Date }>({
    start: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000), // Default start date (7 days ago)
    end: new Date(), // Default end date (today)
  });

  useEffect(() => {
    setDateFilter(selectedWeek); // Update date filter whenever selectedWeek changes
  }, [selectedWeek, setDateFilter]);

  const formatDateForInput = (date: Date): string => {
    return date.toISOString().split('T')[0]; // Format date for input type 'date'
  };

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedWeek({ ...selectedWeek, start: new Date(e.target.value) }); // Update selectedWeek with new start date
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedWeek({ ...selectedWeek, end: new Date(e.target.value) }); // Update selectedWeek with new end date
  };

  return (
    <div>
      <input
        type="date"
        value={formatDateForInput(selectedWeek.start)}
        onChange={handleStartDateChange}
      />
      <input
        type="date"
        value={formatDateForInput(selectedWeek.end)}
        onChange={handleEndDateChange}
      />
     
      <p>Left Plot: Filtered Right Plot: All </p>
       <p> Select Date Filter (start-end)</p>

    </div>
  );
};
